export default __webpack_public_path__ + "static/media/linkeding.aee49224.svg";